import * as Yup from "yup";

const SigninSchema = Yup.object().shape({
  username: Yup.string().min(5).required("Required"),
  password: Yup.string().min(6).required("Required"),
});

export const loginFormik = {
  validateOnChange: true,
  validateOnBlur: false,
  initialValues: { username: "", password: "" },
  validationSchema: SigninSchema,
};
